// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavItem-module__font-s-10___wCNd2 {
  font-size: 10px !important;
}

.NavItem-module__font-s-12___IC47m {
  font-size: 12px !important;
}

.NavItem-module__font-s-13___AeMi5 {
  font-size: 13px !important;
}

.NavItem-module__font-s-14___eQjLp {
  font-size: 14px !important;
}

.NavItem-module__font-s-15___BBucO {
  font-size: 15px !important;
}

.NavItem-module__font-s-16___ydFZB {
  font-size: 16px !important;
}

.NavItem-module__font-s-18___oGthv {
  font-size: 18px !important;
}

.NavItem-module__font-s-20___JzuQd {
  font-size: 20px !important;
}

.NavItem-module__font-s-22___n7i5m {
  font-size: 22px !important;
}

.NavItem-module__font-s-28___zKIL2 {
  font-size: 28px !important;
}

.NavItem-module__font-w-400___Zp4BP {
  font-weight: 400 !important;
}

.NavItem-module__font-w-500___aXi7B {
  font-weight: 500 !important;
}

.NavItem-module__font-w-600___sXsUI {
  font-weight: 600 !important;
}

.NavItem-module__font-w-700___DG3E1 {
  font-weight: 700 !important;
}

.NavItem-module__p-5___F8wvc {
  padding: 5px !important;
}

.NavItem-module__p-12___SJaGF {
  padding: 12px !important;
}

.NavItem-module__p-16___XAdNH {
  padding: 16px !important;
}

.NavItem-module__p-30___d6Ha0 {
  padding: 30px !important;
}

.NavItem-module__p-b-0___dU5hS {
  padding-bottom: 0 !important;
}

.NavItem-module__p-b-5___WoIVQ {
  padding-bottom: 5px !important;
}

.NavItem-module__p-b-10___aGuKy {
  padding-bottom: 10px !important;
}

.NavItem-module__p-b-12___wa3cx {
  padding-bottom: 12px !important;
}

.NavItem-module__p-b-16___jHvJU {
  padding-bottom: 16px !important;
}

.NavItem-module__p-b-18___HB73g {
  padding-bottom: 18px !important;
}

.NavItem-module__p-b-20___EuB9R {
  padding-bottom: 20px !important;
}

.NavItem-module__p-b-25___TzfbO {
  padding-bottom: 25px !important;
}

.NavItem-module__p-b-30___gLuX4 {
  padding-bottom: 30px !important;
}

.NavItem-module__p-b-50___AJdgC {
  padding-bottom: 50px !important;
}

.NavItem-module__p-t-0___xpKE0 {
  padding-top: 0 !important;
}

.NavItem-module__p-t-12___efWbK {
  padding-top: 12px !important;
}

.NavItem-module__p-t-16___AOHyU {
  padding-top: 16px !important;
}

.NavItem-module__p-t-18___CRkrQ {
  padding-top: 18px !important;
}

.NavItem-module__p-t-20___Y2TCb {
  padding-top: 20px !important;
}

.NavItem-module__p-t-30___kxD7c {
  padding-top: 30px !important;
}

.NavItem-module__p-t-40___ku_c1 {
  padding-top: 40px !important;
}

.NavItem-module__p-t-50___hYvwL {
  padding-top: 50px !important;
}

.NavItem-module__p-l-20___CV1BK {
  padding-left: 20px !important;
}

.NavItem-module__p-l-30___fauXc {
  padding-left: 30px !important;
}

.NavItem-module__p-l-40___xjfPk {
  padding-left: 40px !important;
}

.NavItem-module__p-r-16____t1k4 {
  padding-right: 16px !important;
}

.NavItem-module__p-r-20___A13L7 {
  padding-right: 20px !important;
}

.NavItem-module__p-r-30___DvmwB {
  padding-right: 30px !important;
}

.NavItem-module__p-r-50___ZOXOM {
  padding-right: 50px !important;
}

.NavItem-module__p-r-60___pD6OK {
  padding-right: 60px !important;
}

.NavItem-module__m-b-1___wXnbu {
  margin-bottom: 1px !important;
}

.NavItem-module__m-b-2___tb_Uv {
  margin-bottom: 2px !important;
}

.NavItem-module__m-b-6___pz7uM {
  margin-bottom: 6px !important;
}

.NavItem-module__m-b-8___TYqTP {
  margin-bottom: 8px !important;
}

.NavItem-module__m-b-10___BhboR {
  margin-bottom: 10px !important;
}

.NavItem-module__m-b-14___jCUUO {
  margin-bottom: 14px !important;
}

.NavItem-module__m-b-16___uqI0r {
  margin-bottom: 16px !important;
}

.NavItem-module__m-b-20___mg066 {
  margin-bottom: 20px !important;
}

.NavItem-module__m-b-22___h9L9z {
  margin-bottom: 22px !important;
}

.NavItem-module__m-b-24___xCpwb {
  margin-bottom: 24px !important;
}

.NavItem-module__m-b-30___oxhuG {
  margin-bottom: 30px !important;
}

.NavItem-module__m-b-32___Km9VF {
  margin-bottom: 32px !important;
}

.NavItem-module__m-b-40___iABgQ {
  margin-bottom: 40px !important;
}

.NavItem-module__m-t-2___wiNpQ {
  margin-top: 2px !important;
}

.NavItem-module__m-t-3___VFGhP {
  margin-top: 3px !important;
}

.NavItem-module__m-t-4___vIZ8B {
  margin-top: 4px !important;
}

.NavItem-module__m-t-5___UkR42 {
  margin-top: 5px !important;
}

.NavItem-module__m-t-8___Ic2GI {
  margin-top: 8px !important;
}

.NavItem-module__m-t-10___c0BMG {
  margin-top: 10px !important;
}

.NavItem-module__m-t-15___xR0PR {
  margin-top: 15px !important;
}

.NavItem-module__m-t-16___JukeX {
  margin-top: 16px !important;
}

.NavItem-module__m-t-20___KnBoS {
  margin-top: 20px !important;
}

.NavItem-module__m-t-22___S4gX1 {
  margin-top: 22px !important;
}

.NavItem-module__m-t-30___UPo80 {
  margin-top: 30px !important;
}

.NavItem-module__m-t-32___uzUy4 {
  margin-top: 32px !important;
}

.NavItem-module__m-l-auto___mOtXJ {
  margin-left: auto !important;
}

.NavItem-module__m-l-4___TTLw3 {
  margin-left: 4px !important;
}

.NavItem-module__m-l-5___oZRLP {
  margin-left: 5px !important;
}

.NavItem-module__m-l-6___TamVc {
  margin-left: 6px !important;
}

.NavItem-module__m-l-8___xnWkF {
  margin-left: 8px !important;
}

.NavItem-module__m-l-10___uZifQ {
  margin-left: 10px !important;
}

.NavItem-module__m-l-16___FRVJr {
  margin-left: 16px !important;
}

.NavItem-module__m-l-20___burpr {
  margin-left: 20px !important;
}

.NavItem-module__m-l-24___ufQ0_ {
  margin-left: 24px !important;
}

.NavItem-module__m-l-30___u7wMx {
  margin-left: 30px !important;
}

.NavItem-module__m-l-35___PG0kq {
  margin-left: 35px !important;
}

.NavItem-module__m-l-40___GN7Jh {
  margin-left: 40px !important;
}

.NavItem-module__m-r-8___Noa5m {
  margin-right: 8px !important;
}

.NavItem-module__m-r-10___tVyq5 {
  margin-right: 10px !important;
}

.NavItem-module__m-r-16___ElA6y {
  margin-right: 16px !important;
}

.NavItem-module__m-r-20___hSPD8 {
  margin-right: 20px !important;
}

.NavItem-module__m-r-24___T9ZcH {
  margin-right: 24px !important;
}

.NavItem-module__m-r-30___jIXiN {
  margin-right: 30px !important;
}

.NavItem-module__m-r-40___i2x_2 {
  margin-right: 40px !important;
}

.NavItem-module__border-r-3___awG5J {
  border-radius: 3px !important;
}

.NavItem-module__border-r-4___Rp2ZF {
  border-radius: 4px !important;
}

.NavItem-module__border-r-6___Pxbey {
  border-radius: 6px !important;
}

.NavItem-module__border-r-10___qIGwD {
  border-radius: 10px !important;
}

.NavItem-module__border-r-12___oHEX9 {
  border-radius: 12px !important;
}

.NavItem-module__border-r-16___I6cbB {
  border-radius: 16px !important;
}

.NavItem-module__border-r-50___Qv65l {
  border-radius: 50% !important;
}

.NavItem-module__primary-border___In_v3 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.NavItem-module__primary-border-b___qgjyi {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.NavItem-module__primary-border-t___y0Gt4 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.NavItem-module__primary-border-l___eSNnd {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.NavItem-module__primary-border-r___S6ViY {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.NavItem-module__secondary-border___NUFrS {
  border: 1px solid #637768;
}

.NavItem-module__secondary-border-b___M6BsS {
  border-bottom: 1px solid #637768;
}

.NavItem-module__secondary-border-t___TUNJA {
  border-top: 1px solid #637768;
}

.NavItem-module__secondary-border-l___lFbZD {
  border-left: 1px solid #637768;
}

.NavItem-module__secondary-border-r___xlDvX {
  border-right: 1px solid #637768;
}

.NavItem-module__gap-0___fhUtP {
  gap: 0 !important;
}

.NavItem-module__gap-2___tmjjC {
  gap: 2px !important;
}

.NavItem-module__gap-4___kwCDC {
  gap: 4px !important;
}

.NavItem-module__gap-5___ZUc5q {
  gap: 5px !important;
}

.NavItem-module__gap-6___bphtx {
  gap: 6px !important;
}

.NavItem-module__gap-8___SxQeC {
  gap: 8px !important;
}

.NavItem-module__gap-10___HZpDQ {
  gap: 10px !important;
}

.NavItem-module__gap-12___aWM6N {
  gap: 12px !important;
}

.NavItem-module__gap-14___ZOGBo {
  gap: 14px !important;
}

.NavItem-module__gap-16___Ihlw9 {
  gap: 16px !important;
}

.NavItem-module__gap-18___RNcHh {
  gap: 18px !important;
}

.NavItem-module__gap-20___heG1p {
  gap: 20px !important;
}

.NavItem-module__gap-24___X0kY4 {
  gap: 24px !important;
}

.NavItem-module__gap-26___TKC5q {
  gap: 26px !important;
}

.NavItem-module__gap-30___HwvnO {
  gap: 30px !important;
}

.NavItem-module__gap-32___JBxYm {
  gap: 32px !important;
}

.NavItem-module__gap-40___bW3uE {
  gap: 40px !important;
}

.NavItem-module__gap-50___wdYza {
  gap: 50px !important;
}

.NavItem-module__flex-1___jlDjh {
  flex: 1;
}

.NavItem-module__flex-none___t63IS {
  flex: none !important;
}

.NavItem-module__flex-column___nRJ_h {
  display: flex;
  flex-direction: column !important;
}

.NavItem-module__flex-row___ZvNVZ {
  display: flex;
  flex-direction: row !important;
}

.NavItem-module__vertically-centered___CQU3B {
  display: flex;
  align-items: center !important;
}

.NavItem-module__horizontally-centered___NJe6V {
  display: flex;
  justify-content: center !important;
}

.NavItem-module__horizontally-end___ofvpG {
  display: flex;
  justify-content: end !important;
}

.NavItem-module__vertically-start___SM38y {
  display: flex;
  align-items: start !important;
}

.NavItem-module__space-between___TnpgN {
  display: flex;
  justify-content: space-between !important;
}

.NavItem-module__flex-wrap___ifM7F {
  flex-wrap: wrap !important;
}

.NavItem-module__height-100___VK_SC {
  height: 100%;
}

.NavItem-module__width-50___WKvpz {
  width: 50% !important;
}

.NavItem-module__width-100___DldXr {
  width: 100%;
}

.NavItem-module__cursor-pointer___BdzXo {
  cursor: pointer;
}

.NavItem-module__cursor-not-allowed___VqzF2 {
  cursor: not-allowed !important;
}

.NavItem-module__absolute-centered___eK6y9 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.NavItem-module__absolute___y4kyC {
  position: absolute;
}

.NavItem-module__relative___xgWYB {
  position: relative;
}

.NavItem-module__fixed___KbBq5 {
  position: fixed;
}

.NavItem-module__visible___jvlKf {
  opacity: 1;
}

.NavItem-module__invisible___cCk4V {
  opacity: 0;
}

.NavItem-module__col-90___HEnwE {
  width: 90% !important;
}

.NavItem-module__col-auto___EZlSo {
  width: auto !important;
}

.NavItem-module__medical-tabs___lWN52 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.NavItem-module__medical-table-new___Qf5a6 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.NavItem-module__medical-table-new___Qf5a6:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.NavItem-module__medical-table-new___Qf5a6::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.NavItem-module__medical-table-new___Qf5a6::-webkit-scrollbar-track {
  display: none;
}
.NavItem-module__medical-table-new___Qf5a6.NavItem-module__no-pagination___bVv3Q {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.NavItem-module__medical-table-new___Qf5a6.NavItem-module__no-pagination___bVv3Q:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.NavItem-module__medical-table-new___Qf5a6.NavItem-module__no-pagination___bVv3Q::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.NavItem-module__medical-table-new___Qf5a6.NavItem-module__no-pagination___bVv3Q::-webkit-scrollbar-track {
  display: none;
}

.NavItem-module__medical-table-empty___r09z7 {
  padding: 14px 40px !important;
}

.NavItem-module__icon-btn___Zy4OL {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.NavItem-module__search-icon___fwFgE {
  width: 24px;
  height: 24px;
  align-self: center;
}

.NavItem-module__disable-select___Tb4KN {
  user-select: none;
}

.NavItem-module__break-word___gKHWO {
  word-break: break-word;
}

.NavItem-module__popup-clear-btn___nbFBf {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.NavItem-module__scroll-m-b-20___HTMio {
  scroll-margin-bottom: 20px;
}

.NavItem-module__title___VRB5C {
  font-family: var(--font-family);
  font-weight: 400;
  display: inline-block;
  color: #859989;
  line-height: 150%;
  white-space: nowrap;
}

.NavItem-module__titleIcon___lEUcO {
  width: 15px;
  height: 15px;
}

.NavItem-module__value___dZHYv {
  color: #375844;
  line-height: 150%;
  white-space: nowrap;
}

.NavItem-module__separator___PkjJ6 {
  min-height: 75%;
  width: 0;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/navigation/NavItem/NavItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EEwBE,+BApBO;EAqBP,gBAFmD;EFrBnD,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AA+pBF;;AA5pBA;EACE,WAAA;EACA,YAAA;AA+pBF;;AA5pBA;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;AA+pBF;;AA5pBA;EACE,eAAA;EACA,QAAA;AA+pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.title {\n  @include get-font($roboto);\n  display: inline-block;\n  color: get-color(greenNew, medium);\n  line-height: 150%;\n  white-space: nowrap;\n}\n\n.titleIcon {\n  width: 15px;\n  height: 15px;\n}\n\n.value {\n  color: get-color(greenNew, dark);\n  line-height: 150%;\n  white-space: nowrap;\n}\n\n.separator {\n  min-height: 75%;\n  width: 0;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `NavItem-module__font-s-10___wCNd2`,
	"fontS12": `NavItem-module__font-s-12___IC47m`,
	"fontS13": `NavItem-module__font-s-13___AeMi5`,
	"fontS14": `NavItem-module__font-s-14___eQjLp`,
	"fontS15": `NavItem-module__font-s-15___BBucO`,
	"fontS16": `NavItem-module__font-s-16___ydFZB`,
	"fontS18": `NavItem-module__font-s-18___oGthv`,
	"fontS20": `NavItem-module__font-s-20___JzuQd`,
	"fontS22": `NavItem-module__font-s-22___n7i5m`,
	"fontS28": `NavItem-module__font-s-28___zKIL2`,
	"fontW400": `NavItem-module__font-w-400___Zp4BP`,
	"fontW500": `NavItem-module__font-w-500___aXi7B`,
	"fontW600": `NavItem-module__font-w-600___sXsUI`,
	"fontW700": `NavItem-module__font-w-700___DG3E1`,
	"p5": `NavItem-module__p-5___F8wvc`,
	"p12": `NavItem-module__p-12___SJaGF`,
	"p16": `NavItem-module__p-16___XAdNH`,
	"p30": `NavItem-module__p-30___d6Ha0`,
	"pB0": `NavItem-module__p-b-0___dU5hS`,
	"pB5": `NavItem-module__p-b-5___WoIVQ`,
	"pB10": `NavItem-module__p-b-10___aGuKy`,
	"pB12": `NavItem-module__p-b-12___wa3cx`,
	"pB16": `NavItem-module__p-b-16___jHvJU`,
	"pB18": `NavItem-module__p-b-18___HB73g`,
	"pB20": `NavItem-module__p-b-20___EuB9R`,
	"pB25": `NavItem-module__p-b-25___TzfbO`,
	"pB30": `NavItem-module__p-b-30___gLuX4`,
	"pB50": `NavItem-module__p-b-50___AJdgC`,
	"pT0": `NavItem-module__p-t-0___xpKE0`,
	"pT12": `NavItem-module__p-t-12___efWbK`,
	"pT16": `NavItem-module__p-t-16___AOHyU`,
	"pT18": `NavItem-module__p-t-18___CRkrQ`,
	"pT20": `NavItem-module__p-t-20___Y2TCb`,
	"pT30": `NavItem-module__p-t-30___kxD7c`,
	"pT40": `NavItem-module__p-t-40___ku_c1`,
	"pT50": `NavItem-module__p-t-50___hYvwL`,
	"pL20": `NavItem-module__p-l-20___CV1BK`,
	"pL30": `NavItem-module__p-l-30___fauXc`,
	"pL40": `NavItem-module__p-l-40___xjfPk`,
	"pR16": `NavItem-module__p-r-16____t1k4`,
	"pR20": `NavItem-module__p-r-20___A13L7`,
	"pR30": `NavItem-module__p-r-30___DvmwB`,
	"pR50": `NavItem-module__p-r-50___ZOXOM`,
	"pR60": `NavItem-module__p-r-60___pD6OK`,
	"mB1": `NavItem-module__m-b-1___wXnbu`,
	"mB2": `NavItem-module__m-b-2___tb_Uv`,
	"mB6": `NavItem-module__m-b-6___pz7uM`,
	"mB8": `NavItem-module__m-b-8___TYqTP`,
	"mB10": `NavItem-module__m-b-10___BhboR`,
	"mB14": `NavItem-module__m-b-14___jCUUO`,
	"mB16": `NavItem-module__m-b-16___uqI0r`,
	"mB20": `NavItem-module__m-b-20___mg066`,
	"mB22": `NavItem-module__m-b-22___h9L9z`,
	"mB24": `NavItem-module__m-b-24___xCpwb`,
	"mB30": `NavItem-module__m-b-30___oxhuG`,
	"mB32": `NavItem-module__m-b-32___Km9VF`,
	"mB40": `NavItem-module__m-b-40___iABgQ`,
	"mT2": `NavItem-module__m-t-2___wiNpQ`,
	"mT3": `NavItem-module__m-t-3___VFGhP`,
	"mT4": `NavItem-module__m-t-4___vIZ8B`,
	"mT5": `NavItem-module__m-t-5___UkR42`,
	"mT8": `NavItem-module__m-t-8___Ic2GI`,
	"mT10": `NavItem-module__m-t-10___c0BMG`,
	"mT15": `NavItem-module__m-t-15___xR0PR`,
	"mT16": `NavItem-module__m-t-16___JukeX`,
	"mT20": `NavItem-module__m-t-20___KnBoS`,
	"mT22": `NavItem-module__m-t-22___S4gX1`,
	"mT30": `NavItem-module__m-t-30___UPo80`,
	"mT32": `NavItem-module__m-t-32___uzUy4`,
	"mLAuto": `NavItem-module__m-l-auto___mOtXJ`,
	"mL4": `NavItem-module__m-l-4___TTLw3`,
	"mL5": `NavItem-module__m-l-5___oZRLP`,
	"mL6": `NavItem-module__m-l-6___TamVc`,
	"mL8": `NavItem-module__m-l-8___xnWkF`,
	"mL10": `NavItem-module__m-l-10___uZifQ`,
	"mL16": `NavItem-module__m-l-16___FRVJr`,
	"mL20": `NavItem-module__m-l-20___burpr`,
	"mL24": `NavItem-module__m-l-24___ufQ0_`,
	"mL30": `NavItem-module__m-l-30___u7wMx`,
	"mL35": `NavItem-module__m-l-35___PG0kq`,
	"mL40": `NavItem-module__m-l-40___GN7Jh`,
	"mR8": `NavItem-module__m-r-8___Noa5m`,
	"mR10": `NavItem-module__m-r-10___tVyq5`,
	"mR16": `NavItem-module__m-r-16___ElA6y`,
	"mR20": `NavItem-module__m-r-20___hSPD8`,
	"mR24": `NavItem-module__m-r-24___T9ZcH`,
	"mR30": `NavItem-module__m-r-30___jIXiN`,
	"mR40": `NavItem-module__m-r-40___i2x_2`,
	"borderR3": `NavItem-module__border-r-3___awG5J`,
	"borderR4": `NavItem-module__border-r-4___Rp2ZF`,
	"borderR6": `NavItem-module__border-r-6___Pxbey`,
	"borderR10": `NavItem-module__border-r-10___qIGwD`,
	"borderR12": `NavItem-module__border-r-12___oHEX9`,
	"borderR16": `NavItem-module__border-r-16___I6cbB`,
	"borderR50": `NavItem-module__border-r-50___Qv65l`,
	"primaryBorder": `NavItem-module__primary-border___In_v3`,
	"primaryBorderB": `NavItem-module__primary-border-b___qgjyi`,
	"primaryBorderT": `NavItem-module__primary-border-t___y0Gt4`,
	"primaryBorderL": `NavItem-module__primary-border-l___eSNnd`,
	"primaryBorderR": `NavItem-module__primary-border-r___S6ViY`,
	"secondaryBorder": `NavItem-module__secondary-border___NUFrS`,
	"secondaryBorderB": `NavItem-module__secondary-border-b___M6BsS`,
	"secondaryBorderT": `NavItem-module__secondary-border-t___TUNJA`,
	"secondaryBorderL": `NavItem-module__secondary-border-l___lFbZD`,
	"secondaryBorderR": `NavItem-module__secondary-border-r___xlDvX`,
	"gap0": `NavItem-module__gap-0___fhUtP`,
	"gap2": `NavItem-module__gap-2___tmjjC`,
	"gap4": `NavItem-module__gap-4___kwCDC`,
	"gap5": `NavItem-module__gap-5___ZUc5q`,
	"gap6": `NavItem-module__gap-6___bphtx`,
	"gap8": `NavItem-module__gap-8___SxQeC`,
	"gap10": `NavItem-module__gap-10___HZpDQ`,
	"gap12": `NavItem-module__gap-12___aWM6N`,
	"gap14": `NavItem-module__gap-14___ZOGBo`,
	"gap16": `NavItem-module__gap-16___Ihlw9`,
	"gap18": `NavItem-module__gap-18___RNcHh`,
	"gap20": `NavItem-module__gap-20___heG1p`,
	"gap24": `NavItem-module__gap-24___X0kY4`,
	"gap26": `NavItem-module__gap-26___TKC5q`,
	"gap30": `NavItem-module__gap-30___HwvnO`,
	"gap32": `NavItem-module__gap-32___JBxYm`,
	"gap40": `NavItem-module__gap-40___bW3uE`,
	"gap50": `NavItem-module__gap-50___wdYza`,
	"flex1": `NavItem-module__flex-1___jlDjh`,
	"flexNone": `NavItem-module__flex-none___t63IS`,
	"flexColumn": `NavItem-module__flex-column___nRJ_h`,
	"flexRow": `NavItem-module__flex-row___ZvNVZ`,
	"verticallyCentered": `NavItem-module__vertically-centered___CQU3B`,
	"horizontallyCentered": `NavItem-module__horizontally-centered___NJe6V`,
	"horizontallyEnd": `NavItem-module__horizontally-end___ofvpG`,
	"verticallyStart": `NavItem-module__vertically-start___SM38y`,
	"spaceBetween": `NavItem-module__space-between___TnpgN`,
	"flexWrap": `NavItem-module__flex-wrap___ifM7F`,
	"height100": `NavItem-module__height-100___VK_SC`,
	"width50": `NavItem-module__width-50___WKvpz`,
	"width100": `NavItem-module__width-100___DldXr`,
	"cursorPointer": `NavItem-module__cursor-pointer___BdzXo`,
	"cursorNotAllowed": `NavItem-module__cursor-not-allowed___VqzF2`,
	"absoluteCentered": `NavItem-module__absolute-centered___eK6y9`,
	"absolute": `NavItem-module__absolute___y4kyC`,
	"relative": `NavItem-module__relative___xgWYB`,
	"fixed": `NavItem-module__fixed___KbBq5`,
	"visible": `NavItem-module__visible___jvlKf`,
	"invisible": `NavItem-module__invisible___cCk4V`,
	"col90": `NavItem-module__col-90___HEnwE`,
	"colAuto": `NavItem-module__col-auto___EZlSo`,
	"medicalTabs": `NavItem-module__medical-tabs___lWN52`,
	"medicalTableNew": `NavItem-module__medical-table-new___Qf5a6`,
	"noPagination": `NavItem-module__no-pagination___bVv3Q`,
	"medicalTableEmpty": `NavItem-module__medical-table-empty___r09z7`,
	"iconBtn": `NavItem-module__icon-btn___Zy4OL`,
	"searchIcon": `NavItem-module__search-icon___fwFgE`,
	"disableSelect": `NavItem-module__disable-select___Tb4KN`,
	"breakWord": `NavItem-module__break-word___gKHWO`,
	"popupClearBtn": `NavItem-module__popup-clear-btn___nbFBf`,
	"scrollMB20": `NavItem-module__scroll-m-b-20___HTMio`,
	"title": `NavItem-module__title___VRB5C`,
	"titleIcon": `NavItem-module__titleIcon___lEUcO`,
	"value": `NavItem-module__value___dZHYv`,
	"separator": `NavItem-module__separator___PkjJ6`
};
module.exports = ___CSS_LOADER_EXPORT___;
